import React from 'react';

export type WebsiteSectionVariant = 'default' | 'surface' | 'accent' | 'cta';

export interface WebsiteSectionProps {
  children: React.ReactNode;
  title?: string;
  intro?: string;
  variant?: WebsiteSectionVariant;
  className?: string;
  headerAlign?: 'left' | 'center';
}

const variantClasses: Record<WebsiteSectionVariant, string> = {
  default: '',
  /* Agrupamento suave — borda fina, sem caixa elevada */
  surface: 'lp-surface-soft p-6 sm:p-8 lg:p-10',
  accent: 'lp-surface-soft p-6 sm:p-8',
  cta: 'lp-surface-soft p-6 sm:p-10 lg:p-12',
};

export const WebsiteSection: React.FC<WebsiteSectionProps> = ({
  children,
  title,
  intro,
  variant = 'default',
  className = '',
  headerAlign = 'left',
}) => {
  const isCenter = headerAlign === 'center';

  return (
    <section className={`lp-section-loose ${variantClasses[variant]} ${className}`.trim()}>
      {(title || intro) && (
        <header className={`lp-section-tight ${isCenter ? 'text-center items-center' : ''}`}>
          {title && (
            <h2 className={`lp-heading-section text-balance ${isCenter ? 'mx-auto' : ''}`}>{title}</h2>
          )}
          {intro && (
            <p className={`lp-prose-muted text-pretty ${isCenter ? 'mx-auto max-w-xl' : 'max-w-xl'}`}>
              {intro}
            </p>
          )}
        </header>
      )}
      {children}
    </section>
  );
};
